var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12 23.33.66-.58C18.19 17.92 21 13.71 21 10c0-5.25-4.1-9-9-9s-9 3.75-9 9c0 3.7 2.81 7.92 8.34 12.75l.66.58Zm0-2.67C7.3 16.43 5 12.85 5 10c0-4.1 3.16-7 7-7s7 2.9 7 7c0 2.85-2.3 6.43-7 10.66ZM12 5a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgPin;